import { useEffect, useContext, useState, useCallback } from "react";
import axios from "axios";
import classes from "../Pages.module.css";
import { Skeleton, Row, Col, message, Tooltip, Modal, Button } from "antd";
import { AiFillDelete } from "react-icons/ai";
import { FaPenAlt } from "react-icons/fa";
import DataContext from "../../../Context/dataContext";
import EmployeeTable from "../EmployeeTable/EmployeeTable";
import FormRenderer from "../FormRenderer/FormRenderer";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { canPerformActionOnDay, getDayPermissionMessage } from '../../../utils/checkDayPermission';

const Misc = (props) => {
  console.log(props,"props are in misc");
  const { id1 } = useParams();
  console.log(id1,"id tis this ");
  const employeeData = useContext(DataContext);
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [rows, setRows] = useState(null);
  const [form, setForm] = useState([]); // Instead of null

  // const [urows, setURows] = useState(null);
  const [uform, setUForm] = useState(null);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [id, setID] = useState("");
  const [identifier, setIdentifier] = useState("");
  // const isMounted = useRef(true);
  // const initialLoad = useRef(true);
  console.log(id1,"id1is tkdfjkdfjskafjskfdjskfdjkdfsj");
 
 
 
  const getPermissionFlags = useCallback(() => {

    
    const roleCd = localStorage.getItem("roleCd");
    console.log(roleCd,"role code");
    
  if (roleCd === "1") {
    return {
      canAdd: true,
      canModify: true,
      canDelete: true,
      canQuery: true,
      messages: { add: "", modify: "", delete: "", query: "" }
    };
  }

    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const dayIdx = new Date().getDay();

     // Debug logging for permission data
     console.log('Permission Data:', {
      hasPermissionData: !!employeeData?.permission?.permission,
      isArray: Array.isArray(employeeData.permission?.permission),
      rawData: employeeData?.permission?.permission,
      currentDay: days[dayIdx]
    });

    if (!employeeData?.permission?.permission || !Array.isArray(employeeData.permission?.permission)) {
      return {
        canAdd: false,
        canModify: false,
        canDelete: false,
        canQuery: false,
        messages: {
          add: "No permissions configured",
          modify: "No permissions configured",
          delete: "No permissions configured",
          query: "No permissions configured"
        }
      };
    }

    const formPermission = employeeData.permission.permission.find(p => 
      p.form_name.trim() === title.trim()
    );

    if (!formPermission) {
      return {
        canAdd: false,
        canModify: false,
        canDelete: false,
        canQuery: false,
        messages: {
          add: "No form permissions found",
          modify: "No form permissions found",
          delete: "No form permissions found",
          query: "No form permissions found"
        }
      };
    }

    const canAdd = formPermission.l_add === 'Y' && canPerformActionOnDay(formPermission, 'a');
    const canModify = formPermission.l_modify === 'Y' && canPerformActionOnDay(formPermission, 'm');
    const canDelete = formPermission.l_delete === 'Y' && canPerformActionOnDay(formPermission, 'd');
    const canQuery = formPermission.l_query === 'Y' && canPerformActionOnDay(formPermission, 'q');

    return { canAdd, canModify, canDelete, canQuery, messages: {
      add: formPermission.l_add !== 'Y' ? "You don't have permission to add items" : getDayPermissionMessage(formPermission, 'a'),
      modify: formPermission.l_modify !== 'Y' ? "You don't have permission to modify items" : getDayPermissionMessage(formPermission, 'm'),
      delete: formPermission.l_delete !== 'Y' ? "You don't have permission to delete items" : getDayPermissionMessage(formPermission, 'd'),
      query: formPermission.l_query !== 'Y' ? "You don't have permission to view items" : getDayPermissionMessage(formPermission, 'q')
    }};
  }, [title, employeeData.permission?.permission]);

  const { canAdd, canModify, canDelete, canQuery, messages } = getPermissionFlags();
  console.log(canAdd, canModify, canDelete, canQuery, messages);

  useEffect(() => {
    console.log("calling useffect");
    let isMounted = true; // Local variable for each effect instance
    const controller = new AbortController();
    console.log("calling useffect");
    
    const fetchData = async () => {
      if (!isMounted) return;
      
      try {
        setLoading(true);
        const response = await axios.get(employeeData.URL + "/api/v1/salesMisc/" + id1, {
          withCredentials: true,
          signal: controller.signal
        });
  
        if (!isMounted) return;
  
        const { data } = response.data;
        console.log("title is this ------------------ ");
        console.log("data is ",data);
        console.log(data.tableHeader.form_name);
        setTitle(data.tableHeader.form_name);
        
        const newCols = data.tableData.fields.map(col => ({
          name: col.name,
          title: col.name.split("_").join(" ").toLowerCase(),
        }));
  
        setColumns([
          { name: "V", title: "V" },
          { name: "D", title: "D" },
          { name: "SNO", title: "SNo" },
          ...newCols
        ]);
  
        const newRows = data.tableData.rows.map((row, index) => ({
          V: canModify ? (
            <Tooltip title="Edit" color="#1777C4">
              <Link
                to="#"
                style={{ color: "#1777C4", fontWeight: "bolder" }}
                onClick={(e) => editHandler(e, index, data.tableHeader.row_identifier, row[data.tableHeader.row_identifier], data.tableHeader.master_fields)}
              >
                <FaPenAlt style={{ color: "#1777C4" }} />
              </Link>
            </Tooltip>
          ) : (
            <Tooltip title={messages.modify} color="#1777C4">
              <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                <FaPenAlt style={{ color: "#1777C4" }} />
              </span>
            </Tooltip>
          ),
          D: canDelete ? (
            <Tooltip title="Delete" color="red">
              <Link
                to="#"
                style={{ color: "red", fontWeight: "bolder" }}
                onClick={(e) => deleteHandler(e, data.tableHeader.row_identifier, row[data.tableHeader.row_identifier])}
              >
                <AiFillDelete style={{ color: "red" }} />
              </Link>
            </Tooltip>
          ) : (
            <Tooltip title={messages.delete} color="red">
              <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                <AiFillDelete style={{ color: "red" }} />
              </span>
            </Tooltip>
          ),
          SNO: index + 1,
          ...row
        }));
  
        setRows(newRows);
  
        const inputTypes = data.tableHeader.input_type.split(", ");
        const newForm = data.tableHeader.table_fields.split(", ").map((field, index) => {
          const baseField = {
            value: "",
            label: data.tableHeader.labels.split(", ")[index].split("_").join(" "),
            name: field,
          };
  
          switch(inputTypes[index]) {
            case "Date":
              return { ...baseField, type: "Date" };
            case "Select":
              return {
                ...baseField,
                type: "Select",
                options: data.tableHeader.select_lists.split(";")[index].split(", ").map(item => ({ key: item, name: item }))
              };
            case "Master":
              return { ...baseField, type: "Master", options: data.obj[index] };
            default:
              return { ...baseField, type: "Input" };
          }
        });
  
        setForm(newForm);
      } catch (err) {
        if (!axios.isCancel(err)) {
          message.error("Failed to load data");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };
  
    fetchData(); // Fetch data every time id1 changes
  
    return () => {
      isMounted = false; // Set local isMounted to false on cleanup
      controller.abort();
      setRows(null);
      setForm([]);
    };
  }, [id1, canModify, canDelete, messages.modify, messages.delete, employeeData.URL]);

  const deleteHandler = (event, identifier, code) => {
     console.log(identifier, code);
    setLoading(true);

    axios
      .delete(
        employeeData.URL +
          "/api/v1/salesMisc/" +
          id1 +
          "?identifier=" +
          code.toString(),
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        message.success({
          content: "Record Deleted Successfully!!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        setLoading(false);
        setRows(null);

        axios
          .get(employeeData.URL + "/api/v1/salesMisc/" + id1, {
            withCredentials: true,
          })
          .then((response) => {
            setRows((rows) => {
              let newRows = response.data.data.tableData.rows.map(
                (row, index) => {
                  return {
                    V: (
                      <Tooltip placement="bottom" title="Edit" color="#1777C4">
                        <Link
                          to="#"
                          style={{ color: "#1777C4", fontWeight: "bolder" }}
                          onClick={(event) =>
                            editHandler(
                              event,
                              index,
                              response.data.data.tableHeader.row_identifier,
                              row[
                                response.data.data.tableHeader.row_identifier
                              ],
                              response.data.data.tableHeader.master_fields
                            )
                          }
                        >
                          <FaPenAlt
                            style={{ color: "#1777C4", fontWeight: "bolder" }}
                          />
                        </Link>
                      </Tooltip>
                    ),
                    D: (
                      <Tooltip placement="bottom" title="Delete" color="red">
                        <Link
                          to="#"
                          style={{ color: "red", fontWeight: "bolder" }}
                          onClick={(event) =>
                            deleteHandler(
                              event,
                              response.data.data.tableHeader.row_identifier,
                              row[response.data.data.tableHeader.row_identifier]
                            )
                          }
                        >
                          <AiFillDelete
                            style={{ color: "red", fontWeight: "bolder" }}
                          />
                        </Link>
                      </Tooltip>
                    ),
                    SNO: index + 1,
                    ...row,
                  };
                }
              );
              return newRows;
            });
          })
          .catch((err) => {
            // console.log(err);
          });
      })
      .catch((err) => {
        message.error({
          content: "Some Error Occurred!!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        setLoading(false);
      });
  };

  const editHandler = (event, mainindex, identifier, code, masterFields) => {

    console.log(code, "code is this in edit handler", mainindex, identifier, masterFields);
    const permissions = getPermissionFlags();
    if (!permissions.canModify) {
      return;
    }
    console.log("manoj");
    setLoading(true);

    setUForm(null);

    axios
      .get(employeeData.URL + "/api/v1/salesMisc/" + id1, {
        withCredentials: true,
      })
      .then((response) => {

        console.log(response.data.data, "tttttttttttttr")
        setLoading(false);

        let inputTypes = response.data.data.tableHeader.input_type.split(", ");

        let newRows = response.data.data.tableData.rows.map((row, index) => {
          return {
            V: (
              <Tooltip placement="bottom" title="Edit" color="#1777C4">
                <Link
                  to="#"
                  style={{ color: "#1777C4", fontWeight: "bolder" }}
                  onClick={(event) =>
                    editHandler(
                      event,
                      index,
                      response.data.data.tableHeader.row_identifier,
                      row[response.data.data.tableHeader.row_identifier],
                      response.data.data.tableHeader.master_fields
                    )
                  }
                >
                  <FaPenAlt
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                  />
                </Link>
              </Tooltip>
            ),
            D: (
              <Tooltip placement="bottom" title="Delete" color="red">
                <Link
                  to="#"
                  style={{ color: "red", fontWeight: "bolder" }}
                  onClick={(event) =>
                    deleteHandler(
                      event,
                      response.data.data.tableHeader.row_identifier,
                      row[response.data.data.tableHeader.row_identifier]
                    )
                  }
                >
                  <AiFillDelete
                    style={{ color: "red", fontWeight: "bolder" }}
                  />
                </Link>
              </Tooltip>
            ),
            SNO: index + 1,
            ...row,
          };
        });

        const newUForm = response.data.data.tableHeader.table_fields
          .split(", ")
          .map((field, index) => {
            if (inputTypes[index] === "Input")
              return {
                value: newRows[mainindex][field],
                label: response.data.data.tableHeader.labels
                  .split(", ")
                  [index].split("_")
                  .join(" "),
                name: field,
                type: "Input",
              };

            if (inputTypes[index] === "Date")
              return {
                value: "",
                label: response.data.data.tableHeader.labels
                  .split(", ")
                  [index].split("_")
                  .join(" "),
                name: field,
                type: "Date",
              };

            if (inputTypes[index] === "Select")
              return {
                value: "",
                label: response.data.data.tableHeader.labels
                  .split(", ")
                  [index].split("_")
                  .join(" "),
                name: field,
                type: "Select",
                options: response.data.data.tableHeader.select_lists
                  .split(";")
                  [index].split(", ")
                  .map((item) => {
                    return {
                      key: item,
                      name: item,
                    };
                  }),
              };

            return {
              value: "",
              label: response.data.data.tableHeader.labels
                .split(", ")
                [index].split("_")
                .join(" "),
              name: field,
              type: "Master",
              options: response.data.data.obj[index],
            };
          });
        
        setID(code);
        setIdentifier(identifier);
        let fieldref = masterFields ? masterFields.split("; ") : [];

        // console.log(fieldref);
        // console.log(fieldref);
        // console.log(fieldref);

        newUForm.forEach((item, indexN) => {
          if (item.type === "Master") {
            let codeField = fieldref[indexN].split(" ")[0];
            let nameField = fieldref[indexN].split(" ")[3];
            // console.log(nameField);
            const indexF = item.options.findIndex(
              (element) => element.N === newRows[mainindex][nameField]
            );
            // console.log(indexF);
            item.value = item.options[indexF].C;
          } else item.value = newRows[mainindex][item.name];
        });

        // console.log(newUForm);
        setUForm(newUForm);
     
        setVisible(true);
      })
      .catch((err) => {
        setLoading(false);
        // console.log(err);
      });
  };

  const handleSubmit = (event) => {
    // console.log(form);
    const postData = {};
    form.forEach((element) => {
      postData[element.name] = element.value;
    });

    // console.log(postData);
    setLoading(true);
    console.log(postData,"post data is this to save");
    axios
      .post(employeeData.URL + "/api/v1/salesMisc/" + id1, postData, {
        withCredentials: true,
        credentials: "include",
      })
      .then((response) => {
        // console.log(response);
        // Check the response for success
        if (response.data.status === "success") {
          // Display success message
          message.success({
            content: "Record Added Successfully!!!!",
            className: "custom-class",
            style: {
              marginTop: "20vh",
            },
          });
        } else {
          // Display error message for duplicate data
          message.error({
            content: response.data.message || "Error adding record.",
            className: "custom-class",
            style: {
              marginTop: "20vh",
            },
          });
        }

        setRows(null);
        setLoading(false);
        setForm((form) => {
          const newForm = [...form];
          newForm.forEach((element) => (element.value = ""));

          return newForm;
        });

        axios
          .get(employeeData.URL + "/api/v1/salesMisc/" + id1, {
            withCredentials: true,
          })
          .then((response) => {
            setRows((rows) => {
              let newRows = response.data.data.tableData.rows.map(
                (row, index) => {
                  return {
                    V: (() => {
                      const permissions = getPermissionFlags();
                      return permissions.canModify ? (
                      <Tooltip placement="bottom" title="Edit" color="#1777C4">
                        <Link
                          to="#"
                          style={{ color: "#1777C4", fontWeight: "bolder" }}
                          onClick={(event) =>
                            editHandler(
                              event,
                              index,
                              response.data.data.tableHeader.row_identifier,
                              row[
                                response.data.data.tableHeader.row_identifier
                              ],
                              response.data.data.tableHeader.master_fields
                            )
                          }
                        >
                          <FaPenAlt
                            style={{ color: "#1777C4", fontWeight: "bolder" }}
                          />
                        </Link>
                      </Tooltip>
                    ):(
                      <Tooltip placement="bottom" title={permissions.messages.modify} color="#1777C4">
                            <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                              <FaPenAlt
                                style={{ color: "#1777C4", fontWeight: "bolder" }}
                              />
                            </span>
                          </Tooltip>
                    );
                  })(),
                    D: (() => {
                      const permissions = getPermissionFlags();
                      return permissions.canDelete ? (
                      <Tooltip placement="bottom" title="Delete" color="red">
                        <Link
                          to="#"
                          style={{ color: "red", fontWeight: "bolder" }}
                          onClick={(event) =>
                            deleteHandler(
                              event,
                              response.data.data.tableHeader.row_identifier,
                              row[response.data.data.tableHeader.row_identifier]
                            )
                          }
                        >
                          <AiFillDelete
                            style={{ color: "red", fontWeight: "bolder" }}
                          />
                        </Link>
                      </Tooltip>
                    ):(
                      <Tooltip placement="bottom" title={permissions.messages.delete} color="red">
                            <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                              <AiFillDelete
                                style={{ color: "red", fontWeight: "bolder" }}
                              />
                            </span>
                          </Tooltip>
                    );
                  })(),
                    SNO: index + 1,
                    ...row,
                  };
                }
              );
              return newRows;
            });
          })
          .catch((err) => {
            // console.log(err);
          });
      })
      .catch((err) => {
        setLoading(false);

        message.error({
          content: "please fill all feild!!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
      });
  };

  const handleOk = () => {
    setConfirmLoading(true);
    // console.log("Submitting");
    const postData = {};
    uform.forEach((element) => {
      postData[element.name] = element.value;
    });

    // console.log(postData);

    axios
      .patch(
        employeeData.URL +
          "/api/v1/salesMisc/" +
          id1 +
          "?identifier=" +
          id.toString(),
        postData,
        {
          withCredentials: true,
          credentials: "include",
        }
      )
      .then((response) => {
        console.log(response);
        setConfirmLoading(false);
        setVisible(false);
        if (response.data.status === "success") {
          // Display success message
          message.success({
            content: "Record Added Successfully!!!!",
            className: "custom-class",
            style: {
              marginTop: "20vh",
            },
          });
        } else {
          // Display error message for duplicate data
          message.error({
            content: response.data.message || "Error adding record.",
            className: "custom-class",
            style: {
              marginTop: "20vh",
            },
          });
        }
        setRows(null);
        setLoading(false);
        setID("");
        setIdentifier("");
        setForm((form) => {
          const newForm = [...form];
          newForm.forEach((element) => (element.value = ""));

          return newForm;
        });

        axios
          .get(employeeData.URL + "/api/v1/salesMisc/" + id1, {
            withCredentials: true,
          })
          .then((response) => {
            setRows((rows) => {
              let newRows = response.data.data.tableData.rows.map(
                (row, index) => {
                  return {
                    V: (
                      <Tooltip placement="bottom" title="Edit" color="#1777C4">
                        <Link
                          to="#"
                          style={{ color: "#1777C4", fontWeight: "bolder" }}
                          onClick={(event) =>
                            editHandler(
                              event,
                              index,
                              response.data.data.tableHeader.row_identifier,
                              row[
                                response.data.data.tableHeader.row_identifier
                              ],
                              response.data.data.tableHeader.master_fields
                            )
                          }
                        >
                          <FaPenAlt
                            style={{ color: "#1777C4", fontWeight: "bolder" }}
                          />
                        </Link>
                      </Tooltip>
                    ),
                    D: (
                      <Tooltip placement="bottom" title="Delete" color="red">
                        <Link
                          to="#"
                          style={{ color: "red", fontWeight: "bolder" }}
                          onClick={(event) =>
                            deleteHandler(
                              event,
                              response.data.data.tableHeader.row_identifier,
                              row[response.data.data.tableHeader.row_identifier]
                            )
                          }
                        >
                          <AiFillDelete
                            style={{ color: "red", fontWeight: "bolder" }}
                          />
                        </Link>
                      </Tooltip>
                    ),
                    SNO: index + 1,
                    ...row,
                  };
                }
              );
              return newRows;
            });
          })
          .catch((err) => {
            // console.log(err);
          });
      })
      .catch((err) => {
        setLoading(false);
        setConfirmLoading(false);
        message.error({
          content: "Some Error Occurred!!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
      });
  };


  const handleCancel = () => {
    setVisible(false);
    setConfirmLoading(false);
  };

  
 console.log(form,"form in sales misc");
  return (
    <>
      <Modal
        title="Edit Record"
        visible={visible}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={confirmLoading}
            onClick={handleOk}
          >
            Submit
          </Button>,
        ]}
      >
        <FormRenderer
          loading={loading}
          form={uform}
          setForm={setUForm}
          handleSubmit={handleOk}
          save={false}
        />
      </Modal>

      <Row className={classes["Row"]}>
        <Col md={14}>
          <p className={classes["Title"]}>{title}</p>
        </Col>
        <Col className={classes["Col"]} md={10}></Col>
      </Row>
      <p></p>
      { canAdd ? (
        <FormRenderer
          loading={loading}
          form={form}
          setForm={setForm}
          handleSubmit={handleSubmit}
          save={true}
        />
      ) : (
        <>
           <p>{!form ? "Loading..." : "You don't have permission to add records"}</p>
        </>
      )}
      <hr></hr>
      <p></p>
      {rows && columns.length > 0 ? (
        <EmployeeTable
          val={false}
          data={rows}
          columns={columns}
          deleteHandler={deleteHandler}
          onRow={(record) => ({
            onClick: () => editHandler(record), // Call editHandler with the selected row's data
          })}
        />
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
};

export default Misc;
